module.exports = __webpack_public_path__ + "static/media/BoxArrowDown.606da040.svg";